import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type {
  DriverReportListApiResponse,
  DriverReportTableFilterParams,
} from "interface/driverReport";

const getFormattedParams = (params: DriverReportTableFilterParams = {}) => {
  const formatted: Record<string, string | number> = {
    page: params.page ?? 1,
    limit: params.pageSize ?? 10,
  };
  if (params.sortField && params.sortOrder) {
    formatted.sort = params.sortField;
    formatted.direction = params.sortOrder === "ascend" ? "asc" : "desc";
  }
  const bookingNumber = Array.isArray(params.booking_number)
    ? params.booking_number[0]
    : params.booking_number;
  if (bookingNumber) formatted.booking_number = bookingNumber;
  const userIds = Array.isArray(params.user_id)
    ? params.user_id.filter(Boolean).join("-")
    : params.user_id;
  if (userIds) formatted.user_id = userIds;
  const driverIds = Array.isArray(params.driver_id)
    ? params.driver_id.filter(Boolean).join("-")
    : params.driver_id;
  if (driverIds) formatted.driver_id = driverIds;
  const reportedBy = Array.isArray(params.reported_by)
  ? params.reported_by[0]
  : params.reported_by;

if (reportedBy) formatted.reported_by = reportedBy;
  const createdAt = Array.isArray(params.createdAt)
    ? params.createdAt[0]
    : params.createdAt;
  if (createdAt) formatted.createdAt = createdAt;
  return formatted;
};

export const driverReportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDriverReports: builder.query<
      DriverReportListApiResponse,
      DriverReportTableFilterParams
    >({
      query: (params) => ({
        url: API.GET_DRIVER_REPORT,
        method: "GET",
        params: getFormattedParams(params),
      }),
      providesTags: ["DriverReport"],
    }),
    deleteDriverReport: builder.mutation<
      { statusCode: number; message: string; data?: unknown },
      string
    >({
      query: (id) => ({
        url: `/${API.GET_DRIVER_REPORT}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["DriverReport"],
    }),
  }),
});

export const {
  useGetDriverReportsQuery,
  useDeleteDriverReportMutation,
} = driverReportApi;
